import { render, staticRenderFns } from "./TaskTrashView.vue?vue&type=template&id=2d462844&"
import script from "./TaskTrashView.vue?vue&type=script&lang=js&"
export * from "./TaskTrashView.vue?vue&type=script&lang=js&"
import style0 from "./TaskTrashView.vue?vue&type=style&index=0&id=2d462844&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports